<template>
	<div>
		<div class="barcode-info-scan">
			<img
				src="https://cdn.orderonline.id/img/barcode-scanner.gif"
				class="w-100"
				alt="Ostock"
			/>
		</div>
		<div class="page-barcode-scanner">
			<!-- Menu -->
			<div class="d-flex align-items-center justify-content-end mt-2">
				<div
					class="d-flex align-items-center text-primary  text-sm"
				>
					<span class="mr-1">
						{{
							$tc('global.orders', submissions.length, {
								count: submissions.length,
							})
						}}
					</span>
					<span>{{ $t('Scanned') }}</span>
				</div>
			</div>
			<div class="d-flex align-items-end flex-wrap mb-3">
				<div class="mr-2">
					<label>Type</label>
					<select
						class="form-control form-control-sm"
						v-tooltip="'Scan Object'"
						v-model="type"
						@input="onTypeSelected"
					>
						<option value="order_id">{{ $t('Order ID') }}</option>
						<option value="receipt_number">{{ $t('Receipt Number') }}</option>
					</select>
				</div>
				<div class="mr-2">
					<label>Status</label>
					<select
						class="form-control form-control-sm"
						v-tooltip="'Change Status to'"
						v-model="status"
						@input="onStatusSelected"
					>
						<!-- <option value=''>Pilih Status </option> -->
						<option value="pending">Pending</option>
						<option value="processing">Processing</option>
						<option value="completed">Completed</option>
						<option value="refunded">Refunded</option>
						<option value="cancelled">Cancelled</option>
					</select>
				</div>
				<div class="mr-2 flex-grow-1">
					<!-- <label>Input</label> -->
					<input
						class="input form-control form-control-sm"
						ref="input"
						id="keyword-input"
						autofocus
						v-focus
						v-model="q"
						:disabled="isUpdating"
						@click="selectText"
						@keyup.enter="onKeywordInput"
					/>
				</div>
				<div>
					<button
						class="btn btn-primary btn-sm"
						:class="{ 'is-loading': isUpdating }"
						@click="updateOrder"
					>
						Update
					</button>
				</div>
			</div>

			<div class="alert alert-info mb-3">
				{{ information }}
			</div>

			<!-- Main Table -->
			<div class="barcode-list table-responsive">
				<table class="barcode-list-table table table-striped table-hover">
					<thead>
						<tr>
							<!-- <th width="3%">
								<label class="input-checkbox-container">
									<input
										type="checkbox"
										class="input-checkbox"
										v-model="selectAll"
									/>
									<span></span>
								</label>
							</th> -->
							<th>
								{{ $t('Order ID') }}
							</th>
							<th>
								{{ $t('Receipt Number') }}
							</th>
							<th>
								{{ $t('Courier') }}
							</th>
							<th>
								{{ $t('Name') }}
							</th>
							<!-- <th>
								{{ $t('Phone') }}
							</th>
							<th>
								{{ $t('Email') }}
							</th>
							<th>
								{{ $t('Status') }}
							</th>
							<th>
								{{ $t('Courier') }}
							</th>
							<th>
								{{ $t('Receipt Number') }}
							</th>
							<th>
								{{ $t('Shipping Cost') }}
							</th>
							<th>
								{{ $t('Price') }}
							</th> -->
						</tr>
					</thead>
					<tbody>
						<tr v-for="(submission, index) in submissions" :key="index">
							<!-- Checkbox -->
							<!-- <td>
								<label class="input-checkbox-container">
									<input
										type="checkbox"
										class="input-checkbox"
										:value="reseller"
										v-model="selected"
										@change="handleReseller({ reseller, event: $event })"
									/>
									<span></span>
								</label>
							</td> -->
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.order_id }}
									</span>
									<!-- <span v-else>-</span> -->
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.shipping.receipt_number }}
									</span>
									<!-- <span v-else>-</span> -->
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.shipping.courier }}
									</span>
									<!-- <span v-else>-</span> -->
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.customer_data.name }}
									</span>
									<!-- <span v-else>-</span> -->
								</div>
							</td>
						</tr>
					</tbody>
				</table>

				<!-- Table Loader -->
				<div class="table-fetch-status" v-if="isUpdating">
					<div class="is-loading large dark m-auto"></div>
				</div>

				<!-- Table Empty -->
				<div
					class="list-empty b-0"
					v-if="submissions.length === 0 && isUpdating === false"
				>
					<span>{{ $t('Start Scanning') }}</span>
				</div>

				<div
					class="table-vertical-scroll hidden-sm"
					id="orders-list-vertical-scroll"
				>
					<div
						class="table-vertical-scroll-content"
						id="orders-list-vertical-scroll-content"
					></div>
				</div>
			</div>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!--  -->
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import '@/lib/typedef';
import {
	delay,
	formatMoney,
	getAxiosErrorMessage,
	toTitleCase,
} from '@/lib/helper';
import utilitiesApi from '@/api/utilities';

export default {
	name: 'NewBarcodeScanner',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	components: {},
	data() {
		return {
			status: 'completed',
			isUpdating: false,
			isAll: false,
			submissions: [],
			q: '',
			code: '',
			type: 'order_id',
			selected: [],
			isValidateError: {
				tier: false,
			},
			isReading: false,
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
		}),

		// Retrun all string with capitalize
		formatMoney(val) {
			return formatMoney(val);
		},

		selectText() {
			this.$refs.input.select();
		},

		onKeywordInput() {
			delay(() => {
				if (this.q && this.q.trim() !== '') {
					this.updateOrder();
				}
			}, 500);
		},

		// Fetch contact data using vuex on contact module
		updateOrder() {
			if (this.q === '') {
				this.setFocus();
				return;
			}
			if (this.isUpdating) return;
			this.isUpdating = true;
			const params = this.fetchParams;
			const callback = (response) => {
				const updatedSubmission = response.data;
				if (updatedSubmission) {
					const submissionIndex = this.submissions.findIndex(
						curr => curr.order_id === updatedSubmission.order_id,
					);
					if (submissionIndex === -1) {
						this.submissions.unshift(updatedSubmission);
					}
				}
				this.isUpdating = false;
				// this.selectText();
				this.clear();
				this.setFocus();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update order',
					text: message,
				});
				this.isUpdating = false;
				this.clear();
				this.setFocus();
			};
			utilitiesApi.updateOrderStatus(params, callback, errorCallback);
		},

		clear() {
			this.q = '';
			this.code = '';
		},

		fetchData() {
			//
		},

		init() {
			this.initBarcodeListener();
		},

		onUserLoaded() {
			this.init();
		},

		setFocus() {
			const input = document.getElementById('keyword-input');
			if (input) {
				input.focus();
			}
		},

		onTypeSelected() {
			this.setFocus();
		},

		onStatusSelected() {
			this.setFocus();
		},

		onBarcodeScan(e) {
			// usually scanners throw an 'Enter' key at the end of read
			if (e.key === 'Enter') {
				this.q = this.code;
				this.updateOrder();
			} else {
				this.code += e.key; // while this is not an 'enter' it stores the every key
			}

			// run a timeout of 200ms at the first read and clear everything
			// if (!this.isReading) {
			// 	this.isReading = true;
			// 	setTimeout(() => {
			// 		this.code = '';
			// 		this.isReading = false;
			// 	}, 200);  //200 works fine for me but you can adjust it
			// }
		},

		initBarcodeListener() {
			document.addEventListener('keypress', this.onBarcodeScan);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
			locale: 'locale',
			store: 'store',
		}),
		fetchParams() {
			const params = {
				status: this.status,
			};

			if (this.type === 'order_id') {
				params.order_id = this.q;
			} else if (this.type === 'receipt_number') {
				params.receipt_number = this.q;
			}

			return params;
		},
		information() {
			let type = '';
			if (this.type === 'order_id') {
				type = 'Order ID';
			} else if (this.type === 'receipt_number') {
				type = 'Receipt Number';
			}
			const status = toTitleCase(this.status);
			const information = `Scan the ${type} barcode, and the order status will be updated to ${status}`;
			return information;
		},
	},
	watch: {
		user() {
			this.onUserLoaded();
		},
	},
	created() {
		if (this.user) {
			this.onUserLoaded();
		}
		// window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		// window.removeEventListener('scroll', this.handleScroll);
		document.removeEventListener('keypress', this.onBarcodeScan);
	},
	updated() {},
	directives: {
		focus: {
			// directive definition
			inserted(el) {
				el.focus();
			},
		},
	},
};
</script>
<style scoped>
.form-control-sm {
	height: calc(1.5em + 0.5rem + 2px) !important;
}
.barcode-info-scan {
	margin: -24px -24px 0 -24px;
}
.text-sm {
	font-size: 0.9em;
}
.barcode-list {
    border: 1px solid #ddd;
    border-top: 0;
    min-height: 100px;
    overflow-y: auto;
}
.barcode-list-table {
    margin-bottom: 1px;
    font-size: .9em;
}
.list-empty {
    padding: 2em 1em;
    font-size: 1.2em;
    text-align: center;
    background-color: #fff;
    border-radius: 3px;
    color: #b1b1b1;
}
</style>
